module.exports = __webpack_public_path__ + "3fd4700cf5eb83785c2baf4ddeb76209.png";